module.exports = __webpack_public_path__ + "static/img/MONACO-MAPLE.411bcba.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MONACO-MAPLE.png
// module id = ObUA
// module chunks = 0